var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame"},[React.createElement("path",{"id":"Vector","d":"M6.88867 9.33325H31.7776","stroke":"#008060","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M6.88867 18.6667H31.7776","stroke":"#008060","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Menu.defaultProps = {"width":"38","height":"28","viewBox":"0 0 38 28","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
